import { Routes } from "@angular/router";
import { loadTranslationResolver } from "@app/kernel/translations/resolvers/load-translations.resolver";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";
import { EmployeeApiService } from "./domains/employees/services/employee-api.service";
import { BrokerApiService } from "./domains/brokers/services/broker-api.service";
import { TelecomOperatorApiService } from "./domains/telecom-operators/services/telecom-operator-api.service";

export const usersRoutes: Routes = [
  {
    path: "employees",
    loadChildren: () => import("./domains/employees/employees.routes").then(r => r.employeesRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.EMPLOYEE.VIEW },
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.ROOT,
        TRANSLATION_PATHS.USERS.SHARED,
        TRANSLATION_PATHS.AUTHENTICATION.SHARED,
        TRANSLATION_PATHS.AUTH,
        TRANSLATION_PATHS.AUTHENTICATION.PERMISSION_GROUPS,
        TRANSLATION_PATHS.USERS.EMPLOYEES,
        TRANSLATION_PATHS.SETTINGS.SYSTEM_SETTINGS,
        TRANSLATION_PATHS.AUTHENTICATION.AUDIT_LOGS,
      ]),
    },
    providers: [EmployeeApiService],
  },
  {
    path: "brokers",
    loadChildren: () => import("./domains/brokers/brokers.routes").then(r => r.brokersRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.BROKER.VIEW },
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.ROOT,
        TRANSLATION_PATHS.USERS.SHARED,
        TRANSLATION_PATHS.AUTHENTICATION.SHARED,
        TRANSLATION_PATHS.AUTH,
        TRANSLATION_PATHS.AUTHENTICATION.PERMISSION_GROUPS,
        TRANSLATION_PATHS.USERS.BROKERS,
        TRANSLATION_PATHS.SETTINGS.SYSTEM_SETTINGS,
        TRANSLATION_PATHS.AUTHENTICATION.AUDIT_LOGS,
      ]),
    },
    providers: [BrokerApiService],
  },
  {
    path: "telecom-operators",
    loadChildren: () => import("./domains/telecom-operators/telecom-operators.routes").then(r => r.telecomOperatorRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.TELECOM_OPERATOR.VIEW },
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.ROOT,
        TRANSLATION_PATHS.USERS.SHARED,
        TRANSLATION_PATHS.AUTHENTICATION.SHARED,
        TRANSLATION_PATHS.AUTH,
        TRANSLATION_PATHS.AUTHENTICATION.PERMISSION_GROUPS,
        TRANSLATION_PATHS.USERS.TELECOM_OPERATORS,
        TRANSLATION_PATHS.SETTINGS.SYSTEM_SETTINGS,
        TRANSLATION_PATHS.AUTHENTICATION.AUDIT_LOGS,
      ]),
    },
    providers: [TelecomOperatorApiService],
  },
];
